import Controller from '@ember/controller';
import { service } from '@ember/service';

export default class HotelSettingsSpiderSpiderDashboardController extends Controller {
  queryParams = ['legacy_mapping_settings'];

  @service('hotel-and-market') hotelAndMarketService;

  dashboard;

  get iframeQPs() {
    return {
      iframe: 1,
      origin: window.location.origin,
      subscriptionId: this.hotelAndMarketService.hotel.id,
      legacy_mapping_settings: this.legacy_mapping_settings,
    };
  }
}
